import { useQuery } from '@mint-lib/query-client';
import { Auth } from '@mint-sdk/api-auth';

type Options = {
  enabled: boolean;
};

const useUserListData = ({ enabled }: Options) => {
  return useQuery({
    ...Auth.listAllUsers({ params: { limit: 0 } }),
    staleTime: Infinity,
    enabled,
  });
};

export default useUserListData;
